// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import 'react-datepicker/dist/react-datepicker.css';

import React, { useRef, useContext, useEffect, useState, useCallback, ChangeEvent, useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import RadioInput from '../../../components/RadioInput';
import S from './styles';
import MemberContext from '../../../contexts/MemberContext';
import { useHistory } from 'react-router-dom';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Subject } from 'rxjs';
import CalendarIcon from '../assets/calendar.svg';
import ReactDatePicker from 'react-datepicker';
import LangContext from '../../../contexts/LanguageContext/LanguageContext';

const UserDataCard = (): JSX.Element => {
  const member = useContext(MemberContext);
  const history = useHistory();
  const [image, setImage] = useState<string>('');
  const [name, setName] = useState<string>('');
  const [gender, setGender] = useState<number>();
  const [birthday, setBirthday] = useState<Date | null>(null);
  const inputImageFileRef = useRef<HTMLInputElement>(null);
  const calendarRef = useRef<ReactDatePicker>(null);
  const inputNameRef = useRef<HTMLInputElement>(null);
  const onSearch$ = useMemo(() => new Subject<Date>(), []);
  const intl = useIntl();
  const languageContext = useContext(LangContext);

  const updateBirthday = useCallback(async (newDate: Date | null) => {
    console.log(newDate)
    if (newDate) {
      setBirthday(newDate);
      await member.update({
        birthday: new Date(newDate).toISOString()
      })
    }
  }, [])
  useEffect(() => {
    const _subscription = onSearch$.pipe(
      debounceTime(1000),
      distinctUntilChanged(),
    ).subscribe({
      next: (date) => updateBirthday(date)
    });

    return () => _subscription.unsubscribe();
  }, [])

  const openCalendar = () => {
    calendarRef.current?.setFocus();
  }

  const handleBirthdayChange = async (data: Date) => {
    setBirthday(data)
    onSearch$.next(data);
  };

  const handleNameChange = (e: ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value);
  }

  const onImageBtnClick = () => {
    inputImageFileRef.current?.click();
  };

  useEffect(() => {
    setImage(member.imageUrl)
    setName(member.username)
    setGender(member.gender)
    setBirthday(member.birthday ? new Date(member.birthday) : null)
  }, [])

  const goChangePassword = () => {
    history.push('/member?changePassword=true')
  }
  const updateName = useCallback(async (newName: string) => {
    setName(newName);
    await member.update({
      username: newName
    })
  }, [])

  const updateGender = useCallback(async (genderId: number) => {
    setGender(genderId);
    await member.update({
      gender: genderId
    })
  }, [])

  async function uploadImage(e: React.ChangeEvent<HTMLInputElement>) {
    const file = e?.target?.files?.[0];
    const reader = new FileReader();
    if (file) {
      reader.readAsDataURL(file);
      reader.onload = () => {
        const url = reader.result as string;
        setImage(url);
      };
      await member.update({
        imageUrl: file
      })
    }
  }

  const genderOptions = useMemo(() => [
    {
      label: intl.formatMessage({ id: 'G002' }),
      value: 1,
      id: 'male'
    },
    {
      label: intl.formatMessage({ id: 'G003' }),
      value: 2,
      id: 'female'
    },
    {
      label: intl.formatMessage({ id: 'G029' }),
      value: 9,
      id: 'polygender'
    }
  ], [intl]);
  console.log(intl)

  const renderUserData = (type: string) => {
    switch (type) {
      case 'name':
        return (
          <S.FormRow>
            <S.FormRowLabel>
              <S.LabelIcon />
              <S.LabelTitle><FormattedMessage id="G001" /></S.LabelTitle>
            </S.FormRowLabel>
            <S.InputWrapper border={true}>
              <S.Input ref={inputNameRef} value={name} onChange={handleNameChange} onBlur={() => updateName(inputNameRef.current ? inputNameRef.current.value : name)} />
            </S.InputWrapper>
          </S.FormRow>
        )
      case 'birthday':
        return (
          <S.FormRow>
            <S.FormRowLabel>
              <S.LabelIcon />
              <S.LabelTitle><FormattedMessage id="G004" /></S.LabelTitle>
            </S.FormRowLabel>
            <S.InputWrapper border={true}>
              <S.InputCalendar
                ref={calendarRef}
                id="birthday"
                name="birthday"
                selected={birthday}
                onChange={(value: Date) => {
                  handleBirthdayChange(value)
                }}
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dateFormat="yyyy/MM/dd"
                dropdownMode="select"
                placeholderText="YYYY/MM/DD"
              />
              <S.IconCalendar src={CalendarIcon} onClick={openCalendar} />
            </S.InputWrapper>
          </S.FormRow>
        )
      case 'organization':
        return (
          <S.FormRow>
            <S.FormRowLabel>
              <S.LabelIcon />
              <S.LabelTitle><FormattedMessage id="G005" /></S.LabelTitle>
            </S.FormRowLabel>
            <S.InputWrapper border={false}>
              {member.organizationName}
            </S.InputWrapper>
          </S.FormRow>
        )
      case 'role':
        return (
          <S.FormRow>
            <S.FormRowLabel>
              <S.LabelIcon />
              <S.LabelTitle><FormattedMessage id="G006" /></S.LabelTitle>
            </S.FormRowLabel>
            <S.InputWrapper border={false}>
              {member.roleName}
            </S.InputWrapper>
          </S.FormRow>
        )
      case 'gender':
        return (
          <S.FormRow>
            <S.FormRowLabel>
              <S.LabelIcon />
              <S.LabelTitle><FormattedMessage id="G028" /></S.LabelTitle>
            </S.FormRowLabel>
            <S.InputWrapper border={false} style={{ justifyContent: 'space-between' }} >
              {genderOptions.map((data, index) => {
                return <RadioInput key={index} onChange={() => updateGender(data.value)} checked={data.value === gender} label={data.label} />
              })}
            </S.InputWrapper>
          </S.FormRow>
        )
    }
  }

  const renderUserProfileHeader = () => {
    return (
      <S.UserTitleWrapper>
        <S.UserPictureContainer>
          {
            member.imageUrl ?
              (<S.UserPicture src={image} />) : <S.UserPictureBlank>{member.email ? member.email[0].toUpperCase() : null}</S.UserPictureBlank>
          }
          <S.FileInput ref={inputImageFileRef} name="image" onChange={uploadImage} />
          <S.UserPictureEditIcon onClick={onImageBtnClick} />
        </S.UserPictureContainer>
        <S.UserEmailCreditWrapper>
          <S.UserEmail>
            {member.email}
          </S.UserEmail>
          <S.UserCredit>
            {member.organizationCredit || 0} Credit
          </S.UserCredit>
        </S.UserEmailCreditWrapper>
      </S.UserTitleWrapper>
    )
  }

  return (
    <S.UserCardContainer>
      {renderUserProfileHeader()}
      <S.UserForm>
        {renderUserData('name')}
        {renderUserData('gender')}
        {renderUserData('birthday')}
        {member.organizationName && renderUserData('organization')}
        {member.roleName && renderUserData('role')}
      </S.UserForm>
      { member?.email.endsWith('@ecloudvalley.com') ? null : <S.ChangePassword onClick={goChangePassword}><FormattedMessage id="G007" /></S.ChangePassword> }
    </S.UserCardContainer>
  )
}
export { UserDataCard as default };
